import React, { Component } from "react";

import { Link } from "react-router-dom";
import Barclasi from "./Barclasi";
import Barclasisin from "./Barclasisin";
import SearchGen from "./SearchGen";
import ButtonPreliminares from "./ButtonPreliminares";

import { jsUcfirst, truncate, calculaPorcentaje } from "../utils/helpers";

export default class Clasificacioncoros extends Component {
	constructor(props) {
		super(props);
		this.state = {
			fase: props.tiempo.cod,
			visible: "comparsa",
			activo: `${props.tiempo.cod}tot`,
			activoTotal: "300",
			activoTxt: "Total",
			fecha: "",
			mainColor: "#F8AF2A",
			botonActivo: "tot"
		};
		// GENERALES
		this.handlerCoro = this.handlerCoro.bind(this);
		this.handlerCuarteto = this.handlerCuarteto.bind(this);
		this.handlerChirigota = this.handlerChirigota.bind(this);
		this.handlerComparsa = this.handlerComparsa.bind(this);
		// CORO ACTIVO
		this.handlerCoroActivoPre = this.handlerCoroActivoPre.bind(this);
		this.handlerCoroActivoTan = this.handlerCoroActivoTan.bind(this);
		this.handlerCoroActivoCup = this.handlerCoroActivoCup.bind(this);
		this.handlerCoroActivoEst = this.handlerCoroActivoEst.bind(this);
		this.handlerCoroActivoPop = this.handlerCoroActivoPop.bind(this);
		this.handlerCoroActivoTip = this.handlerCoroActivoTip.bind(this);
		this.handlerCoroActivoTot = this.handlerCoroActivoTot.bind(this);
		// COMPARSA ACTIVO
		this.handlerComparsaActivoPre = this.handlerComparsaActivoPre.bind(this);
		this.handlerComparsaActivoPas = this.handlerComparsaActivoPas.bind(this);
		this.handlerComparsaActivoCup = this.handlerComparsaActivoCup.bind(this);
		this.handlerComparsaActivoEst = this.handlerComparsaActivoEst.bind(this);
		this.handlerComparsaActivoPop = this.handlerComparsaActivoPop.bind(this);
		this.handlerComparsaActivoTip = this.handlerComparsaActivoTip.bind(this);
		this.handlerComparsaActivoTot = this.handlerComparsaActivoTot.bind(this);
		// CHIRIGOTA ACTIVO
		this.handlerChirigotaActivoPre = this.handlerChirigotaActivoPre.bind(this);
		this.handlerChirigotaActivoPas = this.handlerChirigotaActivoPas.bind(this);
		this.handlerChirigotaActivoCup = this.handlerChirigotaActivoCup.bind(this);
		this.handlerChirigotaActivoEst = this.handlerChirigotaActivoEst.bind(this);
		this.handlerChirigotaActivoPop = this.handlerChirigotaActivoPop.bind(this);
		this.handlerChirigotaActivoTip = this.handlerChirigotaActivoTip.bind(this);
		this.handlerChirigotaActivoTot = this.handlerChirigotaActivoTot.bind(this);
		// CUARTETO ACTIVO
		this.handlerCuartetoActivoPar = this.handlerCuartetoActivoPar.bind(this);
		this.handlerCuartetoActivoCup = this.handlerCuartetoActivoCup.bind(this);
		this.handlerCuartetoActivoEst = this.handlerCuartetoActivoEst.bind(this);
		this.handlerCuartetoActivoOtr = this.handlerCuartetoActivoOtr.bind(this);
		this.handlerCuartetoActivoTip = this.handlerCuartetoActivoTip.bind(this);
		this.handlerCuartetoActivoTot = this.handlerCuartetoActivoTot.bind(this);
	}

	// CALCULA MÁXIMO

	// HANDLER GENERAL
	handlerCoro(e) {
		e.preventDefault();
		this.setState({
			visible: "coro",
			activo: `${this.state.fase}tot`,
			activoTotal: "300",
			activoTxt: "Total",
			mainColor: this.props.getMainColor("cor_x"),
			botonActivo: "tot"
		});
	}
	handlerCuarteto(e) {
		e.preventDefault();
		this.setState({
			visible: "cuarteto",
			activo: `${this.state.fase}tot`,
			activoTotal: "300",
			activoTxt: "Total",
			mainColor: this.props.getMainColor("cua_x"),
			botonActivo: "tot"
		});
	}
	handlerChirigota(e) {
		e.preventDefault();
		this.setState({
			visible: "chirigota",
			activo: `${this.state.fase}tot`,
			activoTotal: "300",
			activoTxt: "Total",
			mainColor: this.props.getMainColor("chi_x"),
			botonActivo: "tot"
		});
	}
	handlerComparsa(e) {
		e.preventDefault();
		this.setState({
			visible: "comparsa",
			activo: `${this.state.fase}tot`,
			activoTotal: "300",
			activoTxt: "Total",
			mainColor: this.props.getMainColor("com_x"),
			botonActivo: "tot"
		});
	}
	// HANDLER CORO
	handlerCoroActivoPre(e) {
		e.preventDefault();
		this.setState({
			activo: `${this.state.fase}pre`,
			activoTxt: "Presentación",
			activoTotal: 18,
			botonActivo: "pre"
		});
	}
	handlerCoroActivoTan(e) {
		e.preventDefault();
		this.setState({
			activo: `${this.state.fase}tan`,
			activoTxt: "Tangos",
			activoTotal: 132,
			botonActivo: "tan"
		});
	}
	handlerCoroActivoCup(e) {
		e.preventDefault();
		this.setState({
			activo: `${this.state.fase}cup`,
			activoTxt: "Cuplés",
			activoTotal: 54,
			botonActivo: "cup"
		});
	}
	handlerCoroActivoEst(e) {
		e.preventDefault();
		this.setState({
			activo: `${this.state.fase}est`,
			activoTxt: "Estribillo",
			activoTotal: 18,
			botonActivo: "est"
		});
	}
	handlerCoroActivoPop(e) {
		e.preventDefault();
		this.setState({
			activo: `${this.state.fase}pop`,
			activoTxt: "Popurri",
			activoTotal: 60,
			botonActivo: "pop"
		});
	}
	handlerCoroActivoTip(e) {
		e.preventDefault();
		this.setState({
			activo: `${this.state.fase}tip`,
			activoTxt: "Tipo",
			activoTotal: 18,
			botonActivo: "tip"
		});
	}
	handlerCoroActivoTot(e) {
		e.preventDefault();
		this.setState({
			activo: `${this.state.fase}tot`,
			activoTotal: 300,
			botonActivo: "tot"
		});
	}
	// HANDLER COMPARSA
	handlerComparsaActivoPre(e) {
		e.preventDefault();
		this.setState({
			activo: `${this.state.fase}pre`,
			activoTxt: "Presentación",
			activoTotal: 18,
			botonActivo: "pre"
		});
	}
	handlerComparsaActivoPas(e) {
		e.preventDefault();
		this.setState({
			activo: `${this.state.fase}pas`,
			activoTxt: "Pasodobles",
			activoTotal: 132,
			botonActivo: "pas"
		});
	}
	handlerComparsaActivoCup(e) {
		e.preventDefault();
		this.setState({
			activo: `${this.state.fase}cup`,
			activoTxt: "Cuplés",
			activoTotal: 54,
			botonActivo: "cup"
		});
	}
	handlerComparsaActivoEst(e) {
		e.preventDefault();
		this.setState({
			activo: `${this.state.fase}est`,
			activoTxt: "Estribillo",
			activoTotal: 18,
			botonActivo: "est"
		});
	}
	handlerComparsaActivoPop(e) {
		e.preventDefault();
		this.setState({
			activo: `${this.state.fase}pop`,
			activoTxt: "Popurri",
			activoTotal: 60,
			botonActivo: "pop"
		});
	}
	handlerComparsaActivoTip(e) {
		e.preventDefault();
		this.setState({
			activo: `${this.state.fase}tip`,
			activoTxt: "Tipo",
			activoTotal: 18,
			botonActivo: "tip"
		});
	}
	handlerComparsaActivoTot(e) {
		e.preventDefault();
		this.setState({
			activo: `${this.state.fase}tot`,
			activoTotal: 300,
			botonActivo: "tot"
		});
	}

	// HANDLER CHIRIGOTA
	handlerChirigotaActivoPre(e) {
		e.preventDefault();
		this.setState({
			activo: `${this.state.fase}pre`,
			activoTxt: "Presentación",
			activoTotal: 18,
			botonActivo: "pre"
		});
	}
	handlerChirigotaActivoPas(e) {
		e.preventDefault();
		this.setState({
			activo: `${this.state.fase}pas`,
			activoTxt: "Pasodobles",
			activoTotal: 72,
			botonActivo: "pas"
		});
	}
	handlerChirigotaActivoCup(e) {
		e.preventDefault();
		this.setState({
			activo: `${this.state.fase}cup`,
			activoTxt: "Cuplés",
			activoTotal: 108,
			botonActivo: "cup"
		});
	}
	handlerChirigotaActivoEst(e) {
		e.preventDefault();
		this.setState({
			activo: `${this.state.fase}est`,
			activoTxt: "Estribillo",
			activoTotal: 24,
			botonActivo: "est"
		});
	}
	handlerChirigotaActivoPop(e) {
		e.preventDefault();
		this.setState({
			activo: `${this.state.fase}pop`,
			activoTxt: "Popurri",
			activoTotal: 60,
			botonActivo: "pop"
		});
	}
	handlerChirigotaActivoTip(e) {
		e.preventDefault();
		this.setState({
			activo: `${this.state.fase}tip`,
			activoTxt: "Tipo",
			activoTotal: 18,
			botonActivo: "tip"
		});
	}
	handlerChirigotaActivoTot(e) {
		e.preventDefault();
		this.setState({
			activo: `${this.state.fase}tot`,
			activoTotal: 300,
			botonActivo: "tot"
		});
	}
	// HANDLER CUARTETO
	handlerCuartetoActivoPar(e) {
		e.preventDefault();
		this.setState({
			activo: `${this.state.fase}par`,
			activoTxt: "Parodia",
			activoTotal: 132,
			botonActivo: "par"
		});
	}
	handlerCuartetoActivoCup(e) {
		e.preventDefault();
		this.setState({
			activo: `${this.state.fase}cup`,
			activoTxt: "Cuplés",
			activoTotal: 72,
			botonActivo: "cup"
		});
	}
	handlerCuartetoActivoEst(e) {
		e.preventDefault();
		this.setState({
			activo: `${this.state.fase}est`,
			activoTxt: "Estribillo",
			activoTotal: 18,
			botonActivo: "est"
		});
	}
	handlerCuartetoActivoOtr(e) {
		e.preventDefault();
		this.setState({
			activo: `${this.state.fase}otr`,
			activoTxt: "Otras",
			activoTotal: 60,
			botonActivo: "otr"
		});
	}
	handlerCuartetoActivoTip(e) {
		e.preventDefault();
		this.setState({
			activo: `${this.state.fase}tip`,
			activoTxt: "Tipo",
			activoTotal: 18,
			botonActivo: "tip"
		});
	}
	handlerCuartetoActivoTot(e) {
		e.preventDefault();
		this.setState({
			activo: `${this.state.fase}tot`,
			activoTotal: 300,
			botonActivo: "tot"
		});
	}
	render() {
		// Filtra tipo y ordena
		const agrVisible = Object.keys(this.props.agrupaciones)
			.filter(key =>
				this.props.agrupaciones[key].cat.includes(this.state.visible)
			)
			.filter(key => this.props.agrupaciones[key].apta === true)
			.sort(
				(a, b) =>
					this.props.agrupaciones[a][`${this.state.fase}tot`] >
					this.props.agrupaciones[b][`${this.state.fase}tot`]
						? -1
						: 1
			);

		// RankClass. Devuelve true si no es empate
		const rankNums = agrVisible.map(
			key => this.props.agrupaciones[key][`${this.state.fase}tot`]
		);
		const rankClass = rankNums.map((key, i) => {
			if (rankNums[i] === rankNums[i + 1] || rankNums[i] === rankNums[i - 1]) {
				return true;
			}
			return false;
		});

		// rankPosicion Devuelve ranking
		let count = [];
		let l = 0;
		const rankPosicion = rankNums.map((x, i) => {
			if (rankNums[i] === rankNums[i - 1]) {
				count.push(l);
				l++;
			} else {
				count.push(l + 1);
				l++;
			}
			return count[i];
		});

		// RANKING
		const activo = this.state.activo;
		const activoTotal = this.state.activoTotal;

		// Ultima sesion
		const ultimasesion = Object.keys(this.props.agrupaciones)
			.filter(key => {
				return this.props.agrupaciones[key][`${this.state.fase}tot`] > 1;
			})
			.reduce((total, key) => {
				if (
					this.props.agrupaciones[key][`${this.state.fase}sesion_num`] > total
				) {
					total = this.props.agrupaciones[key][`${this.state.fase}sesion_num`];
				}
				return total;
			}, 0);

		return (
			<div>
				<div className="tramaBusquedaGen">
					<div className="container" id="busquedaGen">
						<SearchGen history={this.props.history} />
					</div>
				</div>
				<div className="trama">
					<div className="container clasificacion">
						{/* BOTONES GENERALES */}
						<div className="div-area-general">
							<div
								className={this.state.visible === "coro" ? "none" : "div-clasi"}
								onClick={this.handlerCoro}
							>
								<h6 className="div-titulo">Ver coros</h6>
							</div>
							<div
								className={
									this.state.visible === "cuarteto" ? "none" : "div-clasi"
								}
								onClick={this.handlerCuarteto}
							>
								<h6 className="div-titulo">Ver cuartetos</h6>
							</div>
							<div
								className={
									this.state.visible === "chirigota" ? "none" : "div-clasi"
								}
								onClick={this.handlerChirigota}
							>
								<h6 className="div-titulo">Ver chirigotas</h6>
							</div>
							<div
								className={
									this.state.visible === "comparsa" ? "none" : "div-clasi"
								}
								onClick={this.handlerComparsa}
							>
								<h6 className="div-titulo">Ver comparsas</h6>
							</div>
						</div>
						<h1 className="titulo">{jsUcfirst(`${this.state.visible}s`)}</h1>
						<h4 className="titular-activo">
							{`${this.state.activoTxt} `}
							<span className="titular-activo-sub">{`Sobre ${
								this.state.activoTotal
							} ptos.`}</span>
						</h4>
					</div>
				</div>
				{/* ESTADO VISIBLE */}
				{/* BOTONES CORO */}
				<div className="container">
					<div className="button-area">
						<button
							className={`${this.state.visible === "coro" ? "vis" : "none"} ${
								this.state.botonActivo === "pre" ? "vis_active" : ""
							}`}
							onClick={this.handlerCoroActivoPre}
						>
							Presentación
						</button>
						<button
							className={`${this.state.visible === "coro" ? "vis" : "none"} ${
								this.state.botonActivo === "tan" ? "vis_active" : ""
							}`}
							onClick={this.handlerCoroActivoTan}
						>
							Tangos
						</button>
						<button
							className={`${this.state.visible === "coro" ? "vis" : "none"} ${
								this.state.botonActivo === "cup" ? "vis_active" : ""
							}`}
							onClick={this.handlerCoroActivoCup}
						>
							Cuplés
						</button>
						<button
							className={`${this.state.visible === "coro" ? "vis" : "none"} ${
								this.state.botonActivo === "est" ? "vis_active" : ""
							}`}
							onClick={this.handlerCoroActivoEst}
						>
							Estribillo
						</button>
						<button
							className={`${this.state.visible === "coro" ? "vis" : "none"} ${
								this.state.botonActivo === "pop" ? "vis_active" : ""
							}`}
							onClick={this.handlerCoroActivoPop}
						>
							Popurri
						</button>
						<button
							className={`${this.state.visible === "coro" ? "vis" : "none"} ${
								this.state.botonActivo === "tip" ? "vis_active" : ""
							}`}
							onClick={this.handlerCoroActivoTip}
						>
							Tipo
						</button>
						<button
							className={`${this.state.visible === "coro" ? "vis" : "none"} ${
								this.state.botonActivo === "tot" ? "vis_active" : ""
							}`}
							onClick={this.handlerCoroActivoTot}
						>
							Total
						</button>
						{/* BOTONES COMPARSA */}
						<button
							className={`${
								this.state.visible === "comparsa" ? "vis" : "none"
							} ${this.state.botonActivo === "pre" ? "vis_active" : ""}`}
							onClick={this.handlerComparsaActivoPre}
						>
							Presentación
						</button>
						<button
							className={`${
								this.state.visible === "comparsa" ? "vis" : "none"
							} ${this.state.botonActivo === "pas" ? "vis_active" : ""}`}
							onClick={this.handlerComparsaActivoPas}
						>
							Pasodobles
						</button>
						<button
							className={`${
								this.state.visible === "comparsa" ? "vis" : "none"
							} ${this.state.botonActivo === "cup" ? "vis_active" : ""}`}
							onClick={this.handlerComparsaActivoCup}
						>
							Cuplés
						</button>
						<button
							className={`${
								this.state.visible === "comparsa" ? "vis" : "none"
							} ${this.state.botonActivo === "est" ? "vis_active" : ""}`}
							onClick={this.handlerComparsaActivoEst}
						>
							Estribillo
						</button>
						<button
							className={`${
								this.state.visible === "comparsa" ? "vis" : "none"
							} ${this.state.botonActivo === "pop" ? "vis_active" : ""}`}
							onClick={this.handlerComparsaActivoPop}
						>
							Popurri
						</button>
						<button
							className={`${
								this.state.visible === "comparsa" ? "vis" : "none"
							} ${this.state.botonActivo === "tip" ? "vis_active" : ""}`}
							onClick={this.handlerComparsaActivoTip}
						>
							Tipo
						</button>
						<button
							className={`${
								this.state.visible === "comparsa" ? "vis" : "none"
							} ${this.state.botonActivo === "tot" ? "vis_active" : ""}`}
							onClick={this.handlerComparsaActivoTot}
						>
							Total
						</button>
						{/* BOTONES CHIRIGOTA */}
						<button
							className={`${
								this.state.visible === "chirigota" ? "vis" : "none"
							} ${this.state.botonActivo === "pre" ? "vis_active" : ""}`}
							onClick={this.handlerChirigotaActivoPre}
						>
							Presentación
						</button>
						<button
							className={`${
								this.state.visible === "chirigota" ? "vis" : "none"
							} ${this.state.botonActivo === "pas" ? "vis_active" : ""}`}
							onClick={this.handlerChirigotaActivoPas}
						>
							Pasodobles
						</button>
						<button
							className={`${
								this.state.visible === "chirigota" ? "vis" : "none"
							} ${this.state.botonActivo === "cup" ? "vis_active" : ""}`}
							onClick={this.handlerChirigotaActivoCup}
						>
							Cuplés
						</button>
						<button
							className={`${
								this.state.visible === "chirigota" ? "vis" : "none"
							} ${this.state.botonActivo === "est" ? "vis_active" : ""}`}
							onClick={this.handlerChirigotaActivoEst}
						>
							Estribillo
						</button>
						<button
							className={`${
								this.state.visible === "chirigota" ? "vis" : "none"
							} ${this.state.botonActivo === "pop" ? "vis_active" : ""}`}
							onClick={this.handlerChirigotaActivoPop}
						>
							Popurri
						</button>
						<button
							className={`${
								this.state.visible === "chirigota" ? "vis" : "none"
							} ${this.state.botonActivo === "tip" ? "vis_active" : ""}`}
							onClick={this.handlerChirigotaActivoTip}
						>
							Tipo
						</button>
						<button
							className={`${
								this.state.visible === "chirigota" ? "vis" : "none"
							} ${this.state.botonActivo === "tot" ? "vis_active" : ""}`}
							onClick={this.handlerChirigotaActivoTot}
						>
							Total
						</button>
						{/* BOTONES CUARTETO */}
						<button
							className={`${
								this.state.visible === "cuarteto" ? "vis" : "none"
							} ${this.state.botonActivo === "par" ? "vis_active" : ""}`}
							onClick={this.handlerCuartetoActivoPar}
						>
							Parodia
						</button>
						<button
							className={`${
								this.state.visible === "cuarteto" ? "vis" : "none"
							} ${this.state.botonActivo === "cup" ? "vis_active" : ""}`}
							onClick={this.handlerCuartetoActivoCup}
						>
							Cuplés
						</button>
						<button
							className={`${
								this.state.visible === "cuarteto" ? "vis" : "none"
							} ${this.state.botonActivo === "est" ? "vis_active" : ""}`}
							onClick={this.handlerCuartetoActivoEst}
						>
							Estribillo
						</button>
						<button
							className={`${
								this.state.visible === "cuarteto" ? "vis" : "none"
							} ${this.state.botonActivo === "otr" ? "vis_active" : ""}`}
							onClick={this.handlerCuartetoActivoOtr}
						>
							Otras
						</button>
						<button
							className={`${
								this.state.visible === "cuarteto" ? "vis" : "none"
							} ${this.state.botonActivo === "tip" ? "vis_active" : ""}`}
							onClick={this.handlerCuartetoActivoTip}
						>
							Tipo
						</button>
						<button
							className={`${
								this.state.visible === "cuarteto" ? "vis" : "none"
							} ${this.state.botonActivo === "tot" ? "vis_active" : ""}`}
							onClick={this.handlerCuartetoActivoTot}
						>
							Total
						</button>
					</div>

					{agrVisible
						.filter((key, i) => {
							return this.props.agrupaciones[key][this.state.activo] > 0;
						})
						.map((key, i) => {
							return (
								<div
									className="itemclasi"
									className={`itemclasi ${
										rankClass[i] ? "empate" : "noempate"
									}`}
									key={this.props.agrupaciones[key].ide}
								>
									<div>
										<Link
											to={`/agrupaciones/${this.props.agrupaciones[key].ide}`}
										>
											<Barclasi
												indice={rankPosicion[i]}
												clave={truncate(this.props.agrupaciones[key].nom)}
												percent={calculaPorcentaje(
													this.props.agrupaciones[key][this.state.activo],
													this.state.activoTotal
												)}
												puntos={parseInt(
													this.props.agrupaciones[key][this.state.activo]
												)}
												mainColor={this.props.mainColor}
												ultima={ultimasesion}
												clas_sesion_num={
													this.props.agrupaciones[key][
														`${this.state.fase}sesion_num`
													]
												}
												puntostotales={parseInt(this.state.activoTotal)}
											/>
										</Link>
									</div>
								</div>
							);
						})}
					{agrVisible
						.filter(
							(key, i) => this.props.agrupaciones[key][this.state.activo] === 0
						)
						.sort(
							(a, b) =>
								this.props.agrupaciones[a][`${this.state.fase}sesion_num`] >
								this.props.agrupaciones[b][`${this.state.fase}sesion_num`]
									? 1
									: -1
						)

						.map((key, i) => {
							return (
								<div
									className={`sin itemclasi ${
										rankClass[i] ? "empate" : "noempate"
									}`}
									key={this.props.agrupaciones[key].ide + "clasi"}
								>
									<Link
										to={`/agrupaciones/${this.props.agrupaciones[key].ide}`}
									>
										<Barclasisin
											clave={truncate(this.props.agrupaciones[key].nom, 22)}
											fecha={
												this.props.agrupaciones[key][`${this.state.fase}sesion`]
											}
										/>
									</Link>
								</div>
							);
						})}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Clasificacion.js